import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Actions from 'flow/actions';
import { addVideoLogEntry } from 'flow/utils/browser-utils';
import { joinMeetingMuted } from 'flow/actions/meeting-actions';
import { selectNameInApp } from 'flow/selectors/selectors';
import Video2Resource from 'flow/api/videoconference';
export var video2IncomingCall = function video2IncomingCall(payload) {
  return {
    type: Actions.VIDEO2_INCOMING_CALL,
    payload: _objectSpread(_objectSpread({}, payload), {}, {
      direction: 'incoming',
      status: null
    })
  };
};
export var video2OutgoingCall = function video2OutgoingCall(payload) {
  return {
    type: Actions.VIDEO2_OUTGOING_CALL,
    payload: _objectSpread(_objectSpread({}, payload), {}, {
      direction: 'outgoing',
      status: null
    })
  };
};
export var video2ClearState = function video2ClearState() {
  return {
    type: Actions.VIDEO2_CLEAR_CALL_STATE
  };
};
export var video2CallDeclined = function video2CallDeclined(payload) {
  return {
    type: Actions.VIDEO2_CALL_DECLINED,
    payload: payload
  };
};
export var video2CallAccepted = function video2CallAccepted(payload) {
  return {
    type: Actions.VIDEO2_CALL_ACCEPTED,
    payload: payload
  };
};
export var video2CallCanceled = function video2CallCanceled(payload) {
  return {
    type: Actions.VIDEO2_CALL_CANCELED,
    payload: payload
  };
};
export var video2CallHandledOnOtherDevice = function video2CallHandledOnOtherDevice(payload) {
  return {
    type: Actions.VIDEO2_CALL_HANDLED,
    payload: payload
  };
};
export var clearVideo2CallState = function clearVideo2CallState() {
  return function (dispatch) {
    dispatch(video2ClearState());
  };
};
export var handleVideo2OutgoingCall = function handleVideo2OutgoingCall(extensionKey, meetingCode) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            addVideoLogEntry("Starting Video2 call to ".concat(extensionKey, " with meetingCode ").concat(meetingCode));
            dispatch(video2OutgoingCall({
              extensionKey: extensionKey,
              meetingCode: meetingCode
            }));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
export var handleVideo2IncomingCall = function handleVideo2IncomingCall(videoCallDetails) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch) {
      return _regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (videoCallDetails.extensionKey) {
              addVideoLogEntry("Incoming Video2 call from ".concat(videoCallDetails.extensionKey, " with meetingCode ").concat(videoCallDetails.meetingCode));
              dispatch(video2IncomingCall(videoCallDetails));
            }
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};
export var handleVideo2CallDeclined = function handleVideo2CallDeclined(payload) {
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(dispatch) {
      return _regeneratorRuntime.wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            addVideoLogEntry("Video2 call declined by ".concat(payload.extensionKey));
            dispatch(video2CallDeclined(payload));
          case 1:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
};
export var handleVideo2CallAccepted = function handleVideo2CallAccepted(payload) {
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(dispatch, getState) {
      var _state$video, _state$video2;
      var state, meetingCode, direction, nameInApp;
      return _regeneratorRuntime.wrap(function (_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            addVideoLogEntry("Video2 call accepted by ".concat(payload.extensionKey));
            dispatch(video2CallAccepted(payload));
            state = getState();
            meetingCode = (_state$video = state.video2) === null || _state$video === void 0 ? void 0 : _state$video.get('meetingCode'); // This handler also runs on the caller's own client, via the
            // 'video_call_answered' push fired once the other side answers — the
            // caller's meetingCode is already set by handleVideo2OutgoingCall, so
            // without this gate the caller would join (and mute) themselves too.
            // AC-1913 only wants the acceptor muted on join.
            direction = (_state$video2 = state.video2) === null || _state$video2 === void 0 ? void 0 : _state$video2.get('direction');
            if (!(meetingCode && direction === 'incoming')) {
              _context4.next = 2;
              break;
            }
            nameInApp = selectNameInApp(state);
            _context4.next = 1;
            return dispatch(joinMeetingMuted(nameInApp, meetingCode));
          case 1:
            addVideoLogEntry("Joined Video2 call with meetingCode ".concat(meetingCode));
          case 2:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function (_x4, _x5) {
      return _ref4.apply(this, arguments);
    };
  }();
};
export var handleVideo2CallCanceled = function handleVideo2CallCanceled(payload) {
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(dispatch) {
      return _regeneratorRuntime.wrap(function (_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            addVideoLogEntry("Video2 call canceled by ".concat(payload.extensionKey));
            dispatch(video2CallCanceled(payload));
          case 1:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function (_x6) {
      return _ref5.apply(this, arguments);
    };
  }();
};
export var handleVideo2CallHandledOnOtherDevice = function handleVideo2CallHandledOnOtherDevice(payload) {
  return /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6(dispatch, getState) {
      var currentVideoCallState, currentStatus, currentDirection;
      return _regeneratorRuntime.wrap(function (_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            currentVideoCallState = getState().video2;
            currentStatus = currentVideoCallState === null || currentVideoCallState === void 0 ? void 0 : currentVideoCallState.get('status');
            currentDirection = currentVideoCallState === null || currentVideoCallState === void 0 ? void 0 : currentVideoCallState.get('direction');
            if (!(currentStatus === 'accepted' || currentStatus === 'declined')) {
              _context6.next = 1;
              break;
            }
            addVideoLogEntry("Ignoring 'handled on other device' - call already ".concat(currentStatus, " on this device"));
            return _context6.abrupt("return");
          case 1:
            if (currentVideoCallState && currentDirection === 'incoming' && currentStatus === null) {
              addVideoLogEntry("Video2 call handled on other device for ".concat(payload.extensionKey));
              dispatch(video2CallHandledOnOtherDevice(payload));
            } else {
              addVideoLogEntry("Ignoring 'handled on other device' - no active pending incoming call (status: ".concat(currentStatus, ", direction: ").concat(currentDirection, ")"));
            }
          case 2:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return function (_x7, _x8) {
      return _ref6.apply(this, arguments);
    };
  }();
};
export var fetchVideo2Config = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
    return _regeneratorRuntime.wrap(function (_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          return _context7.abrupt("return", new Promise(function (resolve, reject) {
            Video2Resource.getVideoConferenceConfig({
              onResult: function onResult(json) {
                resolve(json);
              },
              onError: function onError(error) {
                return reject(new Error((error === null || error === void 0 ? void 0 : error.message) || 'Failed to get video conference config'));
              }
            });
          }));
        case 1:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return function fetchVideo2Config() {
    return _ref7.apply(this, arguments);
  };
}();
export var fetchVideo2MeetingCode = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8(meetingEntity) {
    return _regeneratorRuntime.wrap(function (_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          if (!meetingEntity) {
            _context8.next = 1;
            break;
          }
          return _context8.abrupt("return", new Promise(function (resolve, reject) {
            Video2Resource.getMeetingCodeForEntity({
              onResult: function onResult(json) {
                resolve(json);
              },
              onError: function onError(error) {
                return reject(new Error((error === null || error === void 0 ? void 0 : error.message) || 'Failed to get meeting code for entity'));
              }
            }, meetingEntity);
          }));
        case 1:
          return _context8.abrupt("return", new Promise(function (resolve, reject) {
            Video2Resource.getMeetingCode({
              onResult: function onResult(json) {
                resolve(json);
              },
              onError: function onError(error) {
                return reject(new Error((error === null || error === void 0 ? void 0 : error.message) || 'Failed to get meeting code'));
              }
            });
          }));
        case 2:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
  return function fetchVideo2MeetingCode(_x9) {
    return _ref8.apply(this, arguments);
  };
}();
export var Video2Call = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee9(extensionKey) {
    return _regeneratorRuntime.wrap(function (_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          return _context9.abrupt("return", new Promise(function (resolve, reject) {
            Video2Resource.call({
              onResult: function onResult(result) {
                return resolve(result);
              },
              onError: function onError(error) {
                return reject(new Error((error === null || error === void 0 ? void 0 : error.message) || 'Failed to make video call'));
              }
            }, extensionKey);
          }));
        case 1:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  }));
  return function Video2Call(_x0) {
    return _ref9.apply(this, arguments);
  };
}();
export var notifyVideoCall = function notifyVideoCall(extensionKey, meetingCode) {
  return function () {
    return new Promise(function (resolve, reject) {
      Video2Resource.notify({
        onResult: function onResult(result) {
          return resolve(result);
        },
        onError: function onError(error) {
          return reject(new Error((error === null || error === void 0 ? void 0 : error.message) || 'Failed to notify video call'));
        }
      }, extensionKey, meetingCode);
    });
  };
};
export var declineVideoCall = /*#__PURE__*/function () {
  var _ref0 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee0(extensionKey) {
    return _regeneratorRuntime.wrap(function (_context0) {
      while (1) switch (_context0.prev = _context0.next) {
        case 0:
          return _context0.abrupt("return", new Promise(function (resolve, reject) {
            Video2Resource.declineVideoCall({
              onResult: function onResult(result) {
                return resolve(result);
              },
              onError: function onError(error) {
                return reject(new Error((error === null || error === void 0 ? void 0 : error.message) || 'Failed to decline video call'));
              }
            }, extensionKey);
          }));
        case 1:
        case "end":
          return _context0.stop();
      }
    }, _callee0);
  }));
  return function declineVideoCall(_x1) {
    return _ref0.apply(this, arguments);
  };
}();
export var answerVideoCall = /*#__PURE__*/function () {
  var _ref1 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee1(extensionKey) {
    return _regeneratorRuntime.wrap(function (_context1) {
      while (1) switch (_context1.prev = _context1.next) {
        case 0:
          return _context1.abrupt("return", new Promise(function (resolve, reject) {
            Video2Resource.answerVideoCall({
              onResult: function onResult(result) {
                return resolve(result);
              },
              onError: function onError(error) {
                return reject(new Error((error === null || error === void 0 ? void 0 : error.message) || 'Failed to answer video call'));
              }
            }, extensionKey);
          }));
        case 1:
        case "end":
          return _context1.stop();
      }
    }, _callee1);
  }));
  return function answerVideoCall(_x10) {
    return _ref1.apply(this, arguments);
  };
}();
export var cancelVideoCall = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee10(extensionKey) {
    return _regeneratorRuntime.wrap(function (_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          return _context10.abrupt("return", new Promise(function (resolve, reject) {
            Video2Resource.cancelVideoCall({
              onResult: function onResult(result) {
                return resolve(result);
              },
              onError: function onError(error) {
                return reject(new Error((error === null || error === void 0 ? void 0 : error.message) || 'Failed to cancel video call'));
              }
            }, extensionKey);
          }));
        case 1:
        case "end":
          return _context10.stop();
      }
    }, _callee10);
  }));
  return function cancelVideoCall(_x11) {
    return _ref10.apply(this, arguments);
  };
}();